import axios from 'axios'
import APP from '@/utils/base'
import {
    getToken
} from '@/utils/auth'
import {
    Message,
    Loading
} from 'element-ui'

let loadingInstance = null
const instance = axios.create({
    withCredentials: true
})

const _headers = {
    'Content-Type': 'application/json',
    'Token': getToken()
}
// 上传图片
export function fnUpload(formData, _cb) {
    let _baseUrl = APP.isTest ? APP.HOST.TEST.FILE_UPLOAD : APP.HOST.OFFICIAL.FILE_UPLOAD
    instance.post(_baseUrl, formData, {
        headers: {
            'Content-Type': 'application/json',
            'Token': getToken()
        }
    }).then(res => {
        const _data = res.data
        if (_data.code == APP.HTTP_STATUS.SUCCESS) {
            _cb && _cb(_data)
        } else {
            Message.error('上传失败，请重试')
        }
    })
}
// 上传文件/视频
export function fnUploadDocOrVideo(formData, _type, _cb) {
    let _baseUrl = (APP.isTest ? APP.HOST.TEST.BASE_URL : APP.HOST.OFFICIAL.BASE_URL) + '/file/uploadFile'
    let _contentType = ''
    if (_type == "video") {
        _contentType = 'application/json'
    } else {
        _contentType = 'multipart/form-data'
    }
    instance.post(_baseUrl, formData, {
        headers: {
            'Content-Type': _contentType,
            'X-Token': getToken()
        }
    }).then(res => {
        _cb && _cb(res.data)
    })
}

export function fnRequestPlatform(_obj, _cb, _task) {
    loadingInstance = Loading.service({
        fullscreen: true,
        background: 'rgba(255,255,255,0.3)',
        spinner: 'el-icon-loading'
    })
    _headers['X-Token'] = getToken()
    delete _headers.Token
    console.log(_task);
    let _baseUrl = APP.isTest ? APP.HOST.TEST.ADMIN_TASK_1_URL : APP.HOST.OFFICIAL.ADMIN_TASK_1_URL
    if (_task == 'task-2') {
        _baseUrl = APP.isTest ? APP.HOST.TEST.ADMIN_TASK_2_URL : APP.HOST.OFFICIAL.ADMIN_TASK_2_URL
    }
    console.log(_baseUrl);
    if (_obj.method.toUpperCase() == 'GET') {
        instance.get(_baseUrl + _obj.url, {
            headers: _headers
        }).then(res => {
            loadingInstance.close();
            _cb && _cb(res.data)
        })
    } else {
        instance.post(_baseUrl + _obj.url, _obj.data, {
            headers: _headers
        }).then(res => {
            loadingInstance.close();
            _cb && _cb(res.data)
        })
    }
}



// WEBPACK FOOTER //
// ./src/utils/upload.js